import { useContext } from 'react';
import { EmojiPickerListContext } from '../context/EmojiPickerListContext';
export var useEmojiPickerListContext = function useEmojiPickerListContext() {
  return useContext(EmojiPickerListContext);
};